// extracted by mini-css-extract-plugin
export default {"col_box":"index_col_box_qegOP","col_navlist":"index_col_navlist_iI39L"};